// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "p.error-boundary{text-align:center;margin-top:20px}", "",{"version":3,"sources":["webpack://./src/common/components/errorBoundary.scss"],"names":[],"mappings":"AAAA,iBACI,iBAAA,CACA,eAAA","sourcesContent":["p.error-boundary{\n    text-align: center;\n    margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
